import { cn } from '@foundation/utils/cn';
import { ButtonHTMLAttributes, ReactNode, forwardRef } from 'react';

export type HeadlessButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  readonly isLoading?: boolean;
  readonly children: ReactNode;
};

function HeadlessButtonComponent(
  {
    children,
    className,
    disabled,
    isLoading = false,
    type = 'button',
    ...buttonProps
  }: HeadlessButtonProps,
  ref: React.ForwardedRef<HTMLButtonElement>,
) {
  const isDisabled = disabled || isLoading;

  return (
    <button
      {...buttonProps}
      ref={ref}
      type={type}
      disabled={isDisabled}
      aria-disabled={isDisabled || undefined}
      aria-busy={isLoading || undefined}
      data-loading={isLoading ? '' : undefined}
      data-disabled={isDisabled ? '' : undefined}
      className={cn(
        'grid grid-cols-1 grid-rows-1 place-items-center shrink-0 whitespace-nowrap cursor-pointer disabled:cursor-not-allowed',
        className,
      )}
    >
      {children}
    </button>
  );
}

export const HeadlessButton = forwardRef(HeadlessButtonComponent);
